import { render, staticRenderFns } from "./WinningNumbersSidebar.vue?vue&type=template&id=580d8e87&scoped=true&"
import script from "./WinningNumbersSidebar.vue?vue&type=script&lang=js&"
export * from "./WinningNumbersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WinningNumbersSidebar.vue?vue&type=style&index=0&id=580d8e87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d8e87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VImg,VRow})
